import axios from './axios'
import Agency from 'Models/Agency'
import BaseDataService from 'DataServices/BaseDataService'

export function baseIndexUrlString () {
  return `/agencies`
}

class Agencies extends BaseDataService {
  async getAll (params) {
    return axios.get(baseIndexUrlString(), { params: params })
      .then(response => response.data.map(d => newAgency(d)))
  }
  async getById ({ id }) {
    return axios.get(`${baseIndexUrlString()}/${id}`)
      .then(response => newAgency(response.data))
      .catch(console.error)
  }

  async getResources ({ agency_id }) {
    let agency = newAgency({ id: agency_id })
    return agency.getResources()
  }
}

function newAgency (agency) {
  return new Agency(agency)
}

export default new Agencies()
